import Switch from '@material-ui/core/Switch'
import { useDispatch } from "react-redux"
import { cambiarInternacionalPaqueteAction } from "../../../ducks/paqueteDuck"
import { ToastMessage } from '../../../global/ToastMessage'
import { DialogMessage } from '../../../global/DialogMessage'
import { offLoadAction, onLoadAnction } from "../../../ducks/loadDuck"
export default function SwitchTipoViaje(props) {
    const { IdPaquete = 0, EsInternacional = false } = props
    const dispatch = useDispatch()
    const handleChange = (event) => {
        DialogMessage.fire({
            title: '¿Está seguro de aplicar este cambio?',
            text: (EsInternacional) ? 'Esto cambiara el paquete al tipo de viaje a nacional' : 'Esto cambiara el paquete al tipo de viaje a internacional',
            showCancelButton: true,
            confirmButtonText: "Aplicar",
            cancelButtonText: "Cancelar",
        }).then((result) => {
            if (result.isConfirmed) {
                dispatch(onLoadAnction({ message: "" }))
                dispatch(cambiarInternacionalPaqueteAction({ EsInternacional: !EsInternacional, IdPaquete })).then(Response => {
                    dispatch(offLoadAction())
                    if (Response.status === 500) {
                        ToastMessage.fire({
                            icon: "error",
                            title: "Ocurrio un problema al actulizar el paquete",
                        })
                        return null
                    }
                    if (Response.status === 400) {
                        ToastMessage.fire({
                            icon: "error",
                            title: Response.Message,
                        })
                        return null
                    }
                    ToastMessage.fire({
                        icon: "success",
                        title: "Ingreso Correcto",
                    })
                })
            }
        })
    }

    return (
        <div>
            <label>
                Tipo viaje
            </label>
            <Switch
                checked={EsInternacional}
                onChange={handleChange}
                name="checkedB"
                inputProps={{ 'aria-label': 'secondary checkbox' }}
            />
        </div>
    );
}